import { Form, Modal } from 'semantic-ui-react';
import styled from '@emotion/styled';
import { BaseSyntheticEvent } from 'react';
import {
  ErrorsContextProvider,
  ModuleBadge,
  RHFormDatePicker,
  RHFormNumberInput,
  ValidationErrors,
} from 'components';
import { Footer } from './Footer';
import { useEditSpeakingSession } from './useEditSpeakingSession';

const formId = 'edit-speaking-session-form';

export const EditSpeakingSession = () => {
  const { form, generalErrors, venue, isFetchingSession, isSaving, handleSubmit } =
    useEditSpeakingSession();

  return (
    <ErrorsContextProvider generalErrors={generalErrors}>
      <Modal open>
        <Modal.Header>Edit Speaking session</Modal.Header>
        <Modal.Content>
          <Form
            id={formId}
            loading={isFetchingSession || isSaving}
            error={generalErrors.length > 0}
            noValidate
            onSubmit={(e: BaseSyntheticEvent) => {
              void form.handleSubmit(handleSubmit)(e);
            }}
          >
            <ValidationErrors />
            <S.ModuleBadge />
            <RHFormDatePicker
              name="sessionDate"
              control={form.control}
              label="Date"
              disabled
              data-testid="session-date"
            />
            <Form.Input label="Venue" value={venue} disabled data-testid="session-venue" />
            <RHFormNumberInput
              label="Test taker admission time"
              name="testTakerAdmissionTimeMinutes"
              control={form.control}
              min={0}
              max={99}
              innerLabel={{ basic: true, content: 'min' }}
              innerLabelPosition="right"
            />
          </Form>
        </Modal.Content>
        <Footer isSaving={isSaving} formId={formId} />
      </Modal>
    </ErrorsContextProvider>
  );
};

const S = {
  ModuleBadge: styled(ModuleBadge)`
    &.ui.label {
      position: absolute;
      right: 1rem;
    }
  `,
};
